<template>
  <div>
    <div
      ref="imagesWrapper"
      class="c-chat__mediaFilesImages">
      <div
        v-for="message in messages"
        :key="message.id"
        class="c-chat__mediaFilesImageItem"
        @click="openImageModal(message)"
        @keydown.esc="closeImageModal">
        <img
          loading="lazy"
          class="s-chat__image u-marginBottom2"
          :src="message.content"
          :alt="message.id" />
      </div>
    </div>
    <portal
      v-if="imageUrl"
      to="modal">
      <ImageModal
        v-model="isImageModalOpen"
        :url="imageUrl" />
    </portal>
    <div
      v-if="chatAttachmentsStore.loadingMessages"
      class="o-flex -alignCenter -center">
      <LoadingSpinner />
    </div>
    <div
      v-if="!chatAttachmentsStore.loadingMessages && messages.length === 0"
      class="o-flex -alignCenter -center t-alignCenter u-colorDark">
      <div>
        <div class="t-h6 u-marginBottom1">{{ $t('chat.media_empty_title') }}</div>
        <div class="t-caption2">{{ $t('chat.media_empty_description') }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue'

import ImageModal from '@/components/ImageModal.vue'
import LoadingSpinner from '@/components/LoadingSpinner.vue'
import constants from '@/constants'
import { useChatAttachmentsStore } from '@/modules/chat/chatAttachmentsStore'
import { useChatStore } from '@/modules/chat/chatStore'

const chatStore = useChatStore()
const chatAttachmentsStore = useChatAttachmentsStore(chatStore.chatThread.azure_chat_thread_id)

const messages = ref([])
const isImageModalOpen = ref(false)
const imageUrl = ref(null)
const hasMore = ref(true)
const page = ref(1)
const imagesWrapper = ref(null)
const totalCount = ref(0)

const loadMessages = async () => {
  try {
    const { data, total } = await chatAttachmentsStore.getMessagesByType(constants.CHAT.MESSAGE_TYPES.IMAGES, page.value)
    messages.value.push(...data)
    totalCount.value = total
  } catch (e) {
    console.error('Failed to load images:', e)
  } finally {
    hasMore.value = messages.value.length < totalCount.value
  }
}

const openImageModal = (message) => {
  imageUrl.value = message.content
  isImageModalOpen.value = true
}
const closeImageModal = () => {
  isImageModalOpen.value = false
  imageUrl.value = null
}

const onScroll = async (e) => {
  const t = e.target
  if (hasMore.value && !chatAttachmentsStore.loadingMessages && t.scrollHeight - t.scrollTop <= t.clientHeight + 50) {
    page.value++
    await loadMessages()
  }
}

loadMessages()

onMounted(() => {
  imagesWrapper.value.addEventListener('scroll', onScroll)
})

onBeforeUnmount(() => {
  imagesWrapper.value.removeEventListener('scroll', onScroll)
})
</script>
